import Gravity from 'Gravity';

const manualSliderContent = () => {
    const timeline = document.querySelector('.gg-timeline');
    if (!timeline) {
        return;
    }
    const controlNavButton = timeline.querySelectorAll('.wp-block-statik-slider__control-nav-button');
    const carousel = timeline.querySelector('.wp-block-statik-slider > .swiper');
    const contentYearArray = carousel.querySelectorAll('.gg-timeline-content__year');
    const navButtonsArray = timeline.querySelectorAll('.wp-block-statik-slider__control-nav-button');
    navButtonsArray.forEach((item, index) => {
        const textNode = document.createElement('p');
        textNode.textContent = contentYearArray[index].textContent;
        item.append(textNode);
    });

    controlNavButton.forEach(button => {
        button.removeAttribute('aria-label');
    });

    carousel.swiper.params.spaceBetween = 20;
    carousel.swiper.update();
};

Gravity.ready(manualSliderContent);
